import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-navbar-secondary',
  imports: [RouterLink],
  template: `
    <nav
      class="navbar navbar-expand-lg navbar-light fixed-top bg-body-tertiary"
    >
      <div class="container">
        <a class="navbar-brand" routerLink="/">
          <img src="/assets/img/navbar_logo_secondary.svg" alt="" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbar">
          <ul class="navbar-nav m-auto mb-2 mb-lg-0 fw-semibold">
            <li class="nav-item">
              <a class="nav-link text-primary" routerLink="/convocatorias">
                CONVOCATORIAS
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-primary" routerLink="/agenda">AGENDA</a>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link text-primary dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                PROGRAMAS
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/programas/licenciaturas"
                  >
                    Licenciaturas
                  </a>
                </li>
              </ul>
            </li>
            <li class="nav-item">
              <a class="nav-link text-primary" routerLink="/galerias">
                GALERÍAS
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link text-primary" routerLink="/acerca-de">
                ACERCA DE
              </a>
            </li>
          </ul>

          <ul class="navbar-nav flex-row ms-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.facebook.com/profile.php?id=61568128125045"
                aria-label="Facebook"
                target="_blank"
                rel="noopener"
              >
                <img src="/assets/icons/facebook.svg" alt="" />
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href="https://x.com/UDEP_Puebla"
                aria-label="Twitter"
                target="_blank"
                rel="noopener"
              >
                <img src="/assets/icons/x.svg" alt="" />
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                href="https://www.instagram.com/udep_puebla/"
                aria-label="Instagram"
                target="_blank"
                rel="noopener"
              >
                <img src="/assets/icons/instagram.svg" alt="" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  `,
  styles: `
    .navbar-nav {
      --bs-nav-link-padding-x: 1rem;
      justify-content: center;
    }
  `
})
export class NavbarSecondaryComponent {}
